import { ref, watch } from "vue";
import { u as useHTMLElement } from "./useHTMLElement-af551f75.mjs";
import { u as useEvent } from "./useEvent-0856a587.mjs";
function useHover(el, disabled) {
  const isHovered = ref(false);
  const onMouseEnter = () => {
    isHovered.value = true;
  };
  const onMouseLeave = () => {
    isHovered.value = false;
  };
  disabled && watch(disabled, (v) => {
    if (v) {
      isHovered.value = false;
    }
  });
  const target = useHTMLElement(el);
  useEvent("mouseenter", onMouseEnter, target);
  useEvent("mouseleave", onMouseLeave, target);
  return { isHovered, onMouseEnter, onMouseLeave };
}
export {
  useHover as u
};
//# sourceMappingURL=useHover-88d786c8.mjs.map
